import React from "react";

import "./Socials.scss";

const Socials = (props) => {

  return (
    <div className="Socials">
      <div className="Socials__text">Follow Us: </div>
      <a
        rel="noreferrer"
        href={`https://linkedin.com/showcase/oracle-analytics`}
        className="Socials__icon Socials__icon--4"
        target="_blank"
      ></a>
      <a
        rel="noreferrer"
        href={`https://twitter.com/oracleanalytics`}
        className="Socials__icon Socials__icon--3"
        target="_blank"
      ></a>
      <a
        rel="noreferrer"
        href={`https://www.facebook.com/OracleAnalytics/`}
        target="_blank"
        className="Socials__icon Socials__icon--2"
      ></a>
    </div>
  );
};

export default Socials;
